<template>
	<div class="customzie">
		<!-- PC端表格布局 -->
		<div class="pc-table">
			<el-table :data="tableData" style="width: 100%;" :key=this.$route.fullpath>
				<el-table-column label="名称" min-width="25%">
					<template slot-scope="scope" >
						<p class="msg">
							<span v-html="scope.row.Name"></span>
						</p>
					</template>
				</el-table-column>
				
				<el-table-column label="要点" min-width="35%" >
					<template slot-scope="scope">
						<p class="msg">
							<span v-html="scope.row.Intro"></span>						
						</p>					
					</template>
				</el-table-column>
				
				<el-table-column label="支持产品" min-width="20%">
					<template slot-scope="scope">
						<span v-html="scope.row.SupportProduct || '-----'"></span>
					</template>
				</el-table-column>
				
				<el-table-column label="版本号" min-width="10%" align="center" v-if="$route.meta.downSign !== 'driver' && $route.meta.downSign !== 'communiate'">
					<template slot-scope="scope">
						<span v-html="scope.row.Version || '-----'"></span>
					</template>
				</el-table-column>
				
				<el-table-column label="大小" min-width="12%" align="center">
					<template slot-scope="scope">
						{{scope.row.Size}}
					</template>
				</el-table-column>
				
				<el-table-column label="操作" min-width="15%" align="center">
					<template slot-scope="scope">
						<el-button size="mini" type="danger" @click="handleEdit(scope.$index, scope.row.FileName)">下载</el-button>
					</template>
				</el-table-column>
				
			</el-table>
		</div>

		<!-- 移动端卡片布局 -->
		<div class="mobile-card-list">
			<div class="mobile-card" v-for="(item, index) in tableData" :key="index">
				<div class="card-item">
					<span class="card-label">名称</span>
					<span class="card-value" v-html="item.Name"></span>
				</div>
				<div class="card-item">
					<span class="card-label">要点</span>
					<span class="card-value msg" v-html="item.Intro"></span>
				</div>
				<div class="card-item">
					<span class="card-label">支持产品</span>
					<span class="card-value">{{ item.SupportProduct || '-----' }}</span>
				</div>
				<div class="card-item" v-if="$route.meta.downSign !== 'driver' && $route.meta.downSign !== 'communiate'">
					<span class="card-label">版本号</span>
					<span class="card-value">{{ item.Version || '-----' }}</span>
				</div>
				<div class="card-item">
					<span class="card-label">大小</span>
					<span class="card-value">{{ item.Size }}</span>
				</div>
				<div class="card-action">
					<el-button size="small" type="danger" @click="handleEdit(index, item.FileName)">下载</el-button>
				</div>
			</div>
		</div>
		
		<ConfirmDialog @confirm="confirm" :showMsg.sync="showMsg"></ConfirmDialog>		
	</div>
</template>

<script>
	// 分页组件
	import Pagination from './Pagination.vue';
	// 确认提示框组件
	import ConfirmDialog from './ConfirmDialog.vue';
	import UploadService from "../../httpcommon/axioInstance.js";

	export default {
		components: {
			Pagination,
			ConfirmDialog,
		},
		data() {
			return {
				// 显示提示框
				showMsg: false,	
				tableData:[]// 				
			};
		},
		computed: {},
		watch: {},
		created() 
		{
			
		},
		mounted() {
			// console.log('this.$route.meta.downSign='+this.$route.meta.downSign)
			
			let s = this.$route.meta.downSign;
			if(s == "cfgPr"){
				this.tableData = [
					{
						Name:'<br/>PLC_Config 2.11.8 Alpha',
						Intro:'<br/>新增设备PAG100、PAG200、VITxxxS、VITxxxN、VITxxxE、CIO211、CIO210',
						SupportProduct:'PAG100、PAG200、VITxxxS、VITxxxN、VITxxxE、CIO211、CIO210',
						Version:'2.11.8 Alpha',
						Size:'22.2M',
						FileName:'PLC_Config 2.11.8 Alpha.exe'
					},
					{
						Name:'<br/>DView2.6.7',
						Intro:'<br/>1.新增通用性设备的支持，新增与西门子300和400通信，新增远程DTU通信方式，完善脚本编译和图元编辑功能。<br/>2.基于HTML5技术，实现了跨平台发布方式，可使用手机进行远程监控。<br/>3.使用2.6版本以上的DView需要更换加密狗。',
						SupportProduct:'所有产品',
						Version:'2.6.7',
						Size:'147.05M',
						FileName:'DView_v2.6.7.10241.exe'
					},
					{
						Name:'<br/>DCCE HMIware',
						Intro:'<br/>DCCE HMIware组态编辑软件,是专为DCCE触摸屏开发的专用人机界面组态软件,该软件为用户提供了一个强大的集成开发环境,产品广泛应用于医疗、化工、电力、印刷、纺织、智能家居等领域',
						SupportProduct:'DCCE触摸屏系列',
						Version:'2.5',
						Size:'138M',
						FileName:'DCCE HMIware v2.5.zip'
					}					
				]
			}
			else if(s == "pdebgSw"){
				this.tableData = [
					{
						Name:'<br/>PEC8000（黑壳）PMC2000（黑壳）用户设置软件',
						Intro:'<br/>支持以太网和串行通讯方式，用户可修改设备IP地址、串口通讯、实时时钟、工程校准值等参数，可查看输入数值，设置输出数值。',
						SupportProduct:'PEC8000、PMC2000（黑壳）',
						Version:'2.0.98',
						Size:'970K',
						FileName:'PEC8000,EDC8000,PMC2000 调试软件 2.0.98（用户版） Setup.exe'
					},
					{
						Name:'<br/>PEC5000（黑壳） AIO5000（黑壳）EDC5000（黑壳） AIO4000（黑壳）用户设置软件',
						Intro:'<br/>支持以太网和串行通讯方式，用户可修改设备IP地址、串口通讯、实时时钟、工程校准值等参数，可查看输入数值，设置输出数值。',
						SupportProduct:'PEC5000、AIO5000、EDC5000、AIO4000（黑壳）',
						Version:'1.4.0',
						Size:'1.47M',
						FileName:'PEC5000,AIO5000,EDC5000,AIO4000调试软件 V1.4.0(用户版).exe'
					},
					{
						Name:'<br/>PEC9000 用户设置软件',
						Intro:'<br/>支持串行通讯方式，用户可修改设备模块地址、串口通讯参数、实时时钟，可查看输入数值，设置输出数值。',
						SupportProduct:'PEC9000',
						Version:'1.2.7',
						Size:'1.15M',
						FileName:'PEC9000调试软件 V1.2.7.exe'
					},
					{
						Name:'<br/>EDC5000-DQ 用户设置软件',
						Intro:'<br/>支持串行通讯方式，用户可修改设备模块地址、串口通讯参数、实时时钟，可查看输入数值，设置输出数值。',
						SupportProduct:'EDC5000-DQ',
						Version:'1.1.0',
						Size:'1.14M',
						FileName:'EDC5000(DQ版)调试软件 V1.1.0.exe'
					},
					{
						Name:'<br/>PEC3000,PEC3400, EDC3000,PES3000, PEC6000用户设置软件',
						Intro:'<br/>支持以太网和串行通讯方式设置，用户可修改设备IP地址、模块地址、串口通讯参数、实时时钟，可查看和设置系统参数。',
						SupportProduct:'PEC3000、PEC3400、EDC3000、PES3000、PEC6000',
						Version:'1.14.0',
						Size:'1.03M',
						FileName:'PEC3xxx,EDC3xxx,PES3xxx,PEC6xxx,PEC2000用户设置软件 V1.14.0(用户版).exe'
					},
					{
						Name:'<br/>MAC系列产品 用户设置软件 测试版',
						Intro:'<br/>支持以太网和串行通讯方式，用户可修改设备IP地址、模块地址、串口通讯参数、实时时钟，可查看输入数值，设置输出数值。',
						SupportProduct:'MAC系列',
						Version:'1.9.5测试版',
						Size:'1.44M',
						FileName:'测试DCCE产品设置软件1.9.5(用户版).exe'
					},
					{
						Name:'<br/>MAC系列产品 用户设置软件',
						Intro:'<br/>支持以太网和串行通讯方式，用户可修改设备IP地址、模块地址、串口通讯参数、实时时钟，可查看输入数值，设置输出数值。',
						SupportProduct:'MAC系列',
						Version:'1.8.18',
						Size:'1.44M',
						FileName:'DCCE产品设置软件 1.8.18(用户版）.exe'
					},					
					{
						Name:'<br/>PEC8000（白壳） PMC2000（白壳） EDC8000 用户设置软件',
						Intro:'<br/>支持以太网和串行通讯方式，用户可修改设备IP地址、串口通讯、实时时钟、工程校准值等参数，可查看输入数值，设置输出数值。',
						SupportProduct:'PEC8000、PMC2000、EDC8000（白壳）',
						Version:'2.0.88',
						Size:'978K',
						FileName:'PEC8000,EDC8000,PMC2000 调试软件 2.0.88 Setup(用户版).exe'
					},
					{
						Name:'<br/>PEC5000（白壳）AIO5000（白壳）EDC5000-AQPEC4000（白壳）AIO4000（白壳）用户设置软件',
						Intro:'<br/>支持以太网和串行通讯方式，用户可修改设备IP地址、串口通讯、实时时钟、工程校准值等参数，可查看输入数值，设置输出数值。',
						SupportProduct:'PEC5000、AIO5000、EDC5000-AQ、PEC4000、AIO4000（白壳）',
						Version:'1.3.99',
						Size:'1.65M',
						FileName:'PEC5000,AIO5000,EDC5000,AIO4000调试软件 V1.3.99(用户版).rar'
					},
					{
						Name:'<br/>PEC3000 PEC3400 EDC3000用户设置软件',
						Intro:'<br/>支持以太网和串行通讯方式，用户可修改设备IP地址、模块地址、串口通讯参数、实时时钟，可查看输入数值，设置输出数值。',
						SupportProduct:'PEC3000、PEC3400、EDC3000',
						Version:'1.13.66',
						Size:'2.46M',
						FileName:'PEC3000,PEC3400,EDC3000 用户设置软件 V1.13.66(用户版)-SETUP.rar'
					},
					{
						Name:'<br/>DIO3000 用户设置软件',
						Intro:'<br/>支持串行通讯方式，用户可修改设备模块地址、串口通讯参数、实时时钟，可查看输入数值，设置输出数值。',
						SupportProduct:'DIO3000',
						Version:'1.1.132',
						Size:'245K',
						FileName:'DIO3000调试软件V1.1.132.rar'
					},
					{
						Name:'<br/>DIO2000 用户设置软件',
						Intro:'<br/>支持串行通讯方式，用户可修改设备模块地址、串口通讯参数，可查看输入数值，设置输出数值。',
						SupportProduct:'DIO2000',
						Version:'1.0',
						Size:'1.7M',
						FileName:'DIO2000 用户设置软件 -Setup.rar'
					},
					{
						Name:'<br/>TAC6000 TAC3000 TAM4000 用户设置软件',
						Intro:'<br/>DUTSetW程序是无条件设置程序，当模块参数设置乱后，使用该程序。使用时将模块SET与V-短路，模块处于设置状态，启动DUTSetW对模块参数进行设置。',
						SupportProduct:'TAC6000、TAC3000、TAM4000',
						Version:'1.0',
						Size:'2.69M',
						FileName:'TAC6000-TAC3000-TAM4000 用户设置软件-DutSetW.rar'
					},
					{
						Name:'<br/>TAC3000专用',
						Intro:'<br/>DUTSetMD是MODBUS下模块测试和设置程序，建议使用该程序对模块参数进行配置。',
						SupportProduct:'TAC3000',
						Version:'1.0',
						Size:'3.37M',
						FileName:'TAC3000 用户设置软件-DutSetMD.rar'
					},
					{
						Name:'<br/>TAC6000,TAM4000专用',
						Intro:'<br/>DUTSetMD是MODBUS下模块测试和设置程序，建议使用该程序对模块参数进行配置。',
						SupportProduct:'TAC6000、TAM4000',
						Version:'1.0',
						Size:'1.72M',
						FileName:'TAC6000-TAM4000 用户设置软件 -SETUP.rar'
					},
					{
						Name:'<br/>DUT4000 用户设置软件',
						Intro:'<br/>支持串行通讯方式，用户可修改设备模块地址、串口通讯参数，可查看输入数值。',
						SupportProduct:'DUT4000',
						Version:'1.0',
						Size:'1.79M',
						FileName:'DUT4000 采集模块DutSetW -Setup.rar'
					},
					{
						Name:'<br/>DIO3400 用户设置软件',
						Intro:'<br/>支持串行通讯方式，用户可修改设备模块地址、串口通讯参数、实时时钟，可查看输入数值，设置输出数值。',
						SupportProduct:'DIO3400',
						Version:'1.0.42',
						Size:'2.67M',
						FileName:'DIO3400 调试软件 V1.0.42版(用户版)-Setup.rar'
					},
					{
						Name:'<br/>调试软件依赖库',
						Intro:'<br/>包含所有调试软件需要的文件，点击安装即可。',
						SupportProduct:'所有产品',
						Version:'2.0',
						Size:'1.8M',
						FileName:'调试软件依赖库2.0(用户版).rar'
					}					
				]
			}
			else if(s == "tools"){
				this.tableData = [
					{
						Name:'<br/>CRC计算工具',
						Intro:'<br/>一款根据填入数据生成CRC校验码的软件。',
						SupportProduct:'所有产品',
						Version:'1.0',
						Size:'6K',
						FileName:'CRC计算工具.rar'
					},
					{
						Name:'<br/>WinRAR试用版',
						Intro:'<br/>WinRAR安装程序。',
						SupportProduct:'所有产品',
						Version:'5.0',
						Size:'1440K',
						FileName:'WinRar解压工具（试用版）.rar'
					},
					{
						Name:'<br/>DCommer',
						Intro:'<br/>一款小巧的以太网和串口数据监视软件。',
						SupportProduct:'所有产品',
						Version:'1.0',
						Size:'170K',
						FileName:'DCommer.rar'
					},
					{
						Name:'<br/>串口调试助手',
						Intro:'<br/>帮助您更方便的调试串口',
						SupportProduct:'所有产品',
						Version:'2.1',
						Size:'118K',
						FileName:'串口调试助手V2.1.exe'
					}
				]
			}
			else if(s == "guide"){
				this.tableData = [
					{
						Name:'爱智控制产品技术手册 2023版',
						Intro:`介绍公司截止2023年的最新概况。<br/>包括产品体系简介、全系列产品功能、技术数据、选型介绍，为您了解产品提供支持`,
						SupportProduct:'所有产品',
						Version:'2023版',
						Size:'103.45M',
						FileName:'2023年爱智控制产品技术手册.pdf'
					},
					{
						Name:'产品宣传手册 2015版',
						Intro:'介绍了2015年最新公司概况、产品体系简介、全系列产品功能、技术数据、选型介绍，为您了解产品提供支持',
						SupportProduct:'所有产品',
						Version:'2015版',
						Size:'26.67M',
						FileName:'2015年大工计控产品技术手册.pdf'
					},
					{
						Name:'技术宣传手册 2013版',
						Intro:'介绍了2013年最新公司概况、协同自动化模型、系统构架、应用案例、产品种类、技术指标、性能特点等，为您了解产品提供支持',
						SupportProduct:'所有产品',
						Version:'2013版',
						Size:'24.9M',
						FileName:'2013年产品技术手册.pdf'
					},
					{
						Name:'产品选型手册 2011版',
						Intro:'介绍了公司概况和2011年产品的性能特点，为您选型提供支持',
						SupportProduct:'所有产品',
						Version:'2011版',
						Size:'13.57M',
						FileName:'2011产品选型手册.pdf'
					}				
				]
			}
			else if(s == "manual"){
				this.tableData = [
					{
						Name:'CIO210可编程控制器使用手册',
						Intro:'介绍了CIO210的功能、安装、接线以及如何使用',
						SupportProduct:'CIO210',
						Version:'V1.0',
						Size:'1.12M',
						FileName:'CIO210可编程控制器使用手册V1.0.pdf'
					},
					{
						Name:'VIT_N_S系列变频器使用手册',
						Intro:'适用于VIT_N系列变频器与VIT_S系列变频器。\n手册中提供了产 品安装、参数设定、异常诊断以及日常维护等内容',
						SupportProduct:'VIT_N、VIT_S系列',
						Version:'V1.0',
						Size:'2.56M',
						FileName:'VIT_N_S系列变频器使用手册V1.0.pdf'
					},
					{
						Name:'大工计控伺服电机手册',
						Intro:'手册中提供了大工计控伺服电机的型号参数',
						SupportProduct:'伺服电机系列',
						Version:'2016版',
						Size:'1.87M',
						FileName:'大工计控伺服电机手册2016-4-21.pdf'
					},
					{
						Name:'VIT_E系列变频器使用手册',
						Intro:'VIT_E系列包括：VIT004E100-1，VIT007E100-1，VIT015E100-1，VIT022E100-1。\n手册中提供了产 品安装、参数设定、异常诊断以及日常维护等内容。',
						SupportProduct:'VIT_E系列',
						Version:'V1.1',
						Size:'2.33M',
						FileName:'VIT_E系列变频器使用手册V1.1.pdf'
					},
					{
						Name:'DCCE HMI通讯连接说明',
						Intro:'介绍了DCCE HMI通讯连接',
						SupportProduct:'DCCE HMI系列',
						Version:'1.0',
						Size:'16.96M',
						FileName:'DCCE HMI通讯连接说明.pdf'
					},
					{
						Name:'DCCE HMIware使用手册',
						Intro:'介绍了DCCE HMIware使用方法与技巧',
						SupportProduct:'DCCE HMIware',
						Version:'1.0',
						Size:'14.43M',
						FileName:'DCCE HMIware使用手册.pdf'
					},
					{
						Name:'CUS_S系列伺服器使用手册',
						Intro:'本使用说明书提供 CUS_S 系列交流伺服驱动器相关信息。',
						SupportProduct:'CUS_S系列',
						Version:'V1.1',
						Size:'3.47M',
						FileName:'CUS_S系列伺服器使用手册V1.1.pdf'
					},
					{
						Name:'触摸屏安装说明',
						Intro:'触摸屏包括：TP107T TP107E TP110T TP110E TP207T TP207E TP210T TP210E。\n该文档提供了DCCE触摸屏的安装说明',
						SupportProduct:'TP系列触摸屏',
						Version:'1.0',
						Size:'1.34M',
						FileName:'触摸屏安装说明.rar'
					},
					{
						Name:'网络化可编程控制器系统手册',
						Intro:'网络化可编程控制器包括：PEC系列、DIO系列、AIO系列、EDC系列、MAC系列、 EA系列、EIO系列。\n介绍了产品的技术指标、安装方式、功能特性、编程特点、指令集等详细情况',
						SupportProduct:'PEC、DIO、AIO、EDC、MAC、EA、EIO系列',
						Version:'1.0',
						Size:'14.78M',
						FileName:'DCCE网络化可编程控制器用户编程手册.pdf'
					},
					{
						Name:'MAC系列可编程控制器使用手册',
						Intro:'MAC系列可编程控制器包括：CPS100、MAC系列、EA系列、EIO系列。\n介绍了MAC系列可编程控制系统的组成，提供了电源、主控器、IO模块的硬件安装接线说明、参数配置说明和示例工程等',
						SupportProduct:'MAC、CPS100、EA、EIO系列',
						Version:'1.0',
						Size:'3.62M',
						FileName:'MAC系列可编程控制器使用手册2019.pdf'
					},
					{
						Name:'PLC_Config用户使用说明书',
						Intro:'介绍了PLC_Config的软件开发、编译、上下载和监控等功能。',
						SupportProduct:'PLC_Config',
						Version:'1.0',
						Size:'4.12M',
						FileName:'PLC_Config用户使用说明书.pdf'
					},
					{
						Name:'CIO110用户使用手册',
						Intro:'介绍了CIO110的功能、安装、接线以及如何使用',
						SupportProduct:'CIO110',
						Version:'1.0',
						Size:'950K',
						FileName:'CIO110用户使用手册.pdf'
					},
					{
						Name:'CIO200用户使用手册',
						Intro:'介绍了CIO200的工作原理、技术参数、安装接线、软件功能以及日常维护与故障排查',
						SupportProduct:'CIO200',
						Version:'1.0',
						Size:'1.64M',
						FileName:'CIO200用户使用手册.pdf'
					},
					{
						Name:'EIO和EA系列产品用户使用手册',
						Intro:'介绍了EIO和EA系列产品的工作原理、技术参数、安装接线、软件功能以及日常维护与故障排查',
						SupportProduct:'EIO、EA系列',
						Version:'1.0',
						Size:'1.45M',
						FileName:'EIO&EA系列产品用户使用手册.pdf'
					},
					{
						Name:'PEC系列可编程控制器使用手册',
						Intro:'介绍了PEC系列可编程控制系统的组成，提供了各种类型控制器的硬件安装接线说明、参数配置说明和示例工程等。\n也包含AIO系列 DIO系列 PMC系列的相关说明。',
						SupportProduct:'PEC、AIO、DIO、PMC系列',
						Version:'1.0',
						Size:'1.52M',
						FileName:'PEC系列可编程控制器使用手册.pdf'
					},
					{
						Name:'PEC8000用户使用手册',
						Intro:'介绍了PEC8000的工作原理、技术参数、安装接线、软件功能以及日常维护与故障排查。\n也包含PMC2000的相关说明。',
						SupportProduct:'PEC8000、PMC2000',
						Version:'1.0',
						Size:'1.93M',
						FileName:'PEC8000用户使用手册.pdf'
					},
					{
						Name:'PEC5000用户使用手册',
						Intro:'介绍了PEC5000的工作原理、技术参数、安装接线、软件功能以及日常维护与故障排查。\n也包含PEC4000的相关说明。',
						SupportProduct:'PEC5000、PEC4000',
						Version:'1.0',
						Size:'1.93M',
						FileName:'PEC5000用户使用手册.pdf'
					},
					{
						Name:'PEC3000用户使用手册',
						Intro:'介绍了PEC3000的工作原理、技术参数、安装接线、软件功能以及日常维护与故障排查。',
						SupportProduct:'PEC3000',
						Version:'1.0',
						Size:'1.57M',
						FileName:'PEC3000用户使用手册.pdf'
					},
					{
						Name:'AIO5000用户使用手册',
						Intro:'介绍了AIO5000的工作原理、技术参数、安装接线、软件功能以及日常维护与故障排查。\n也包含AIO4000的相关说明。',
						SupportProduct:'AIO5000、AIO4000',
						Version:'1.0',
						Size:'1.81M',
						FileName:'AIO5000用户使用手册.pdf'
					},
					{
						Name:'PEC2000用户使用手册',
						Intro:'介绍了PEC2000的工作原理、技术参数、安装接线、软件功能以及日常维护与故障排查',
						SupportProduct:'PEC2000',
						Version:'1.0',
						Size:'2.05M',
						FileName:'PEC2000用户使用手册.pdf'
					},
					{
						Name:'PEC9000用户使用手册',
						Intro:'介绍了PEC9000的工作原理、技术参数、安装接线、软件功能以及日常维护与故障排查',
						SupportProduct:'PEC9000',
						Version:'1.0',
						Size:'1.86M',
						FileName:'PEC9000用户使用手册.pdf'
					},
					{
						Name:'EDC8000用户使用手册',
						Intro:'介绍了EDC8000的工作原理、技术参数、安装接线、软件功能以及日常维护与故障排查',
						SupportProduct:'EDC8000',
						Version:'1.0',
						Size:'2.1M',
						FileName:'EDC8000用户使用手册.pdf'
					},
					{
						Name:'DIO3000用户使用手册',
						Intro:'介绍了DIO3000的工作原理、技术参数、安装接线、软件功能以及日常维护与故障排查',
						SupportProduct:'DIO3000',
						Version:'1.0',
						Size:'1.79M',
						FileName:'DIO3000用户使用手册.pdf'
					},
					{
						Name:'PEC6300用户使用手册',
						Intro:'介绍了PEC6300的工作原理、技术参数、安装接线、软件功能以及日常维护与故障排查',
						SupportProduct:'PEC6300',
						Version:'1.0',
						Size:'2.03M',
						FileName:'PEC6300用户使用手册.pdf'
					},
					{
						Name:'PEC6600用户使用手册',
						Intro:'介绍了PEC6600的工作原理、技术参数、安装接线、软件功能以及日常维护与故障排查',
						SupportProduct:'PEC6600',
						Version:'1.0',
						Size:'2.1M',
						FileName:'PEC6600用户使用手册.pdf'
					},
					{
						Name:'PEC6680用户使用手册',
						Intro:'介绍了PEC6680的工作原理、技术参数、安装接线、软件功能以及日常维护与故障排查',
						SupportProduct:'PEC6680',
						Version:'1.0',
						Size:'2.12M',
						FileName:'PEC6680用户使用手册.pdf'
					},
					{
						Name:'PEC6800用户使用手册',
						Intro:'介绍了PEC6800的工作原理、技术参数、安装接线、软件功能以及日常维护与故障排查',
						SupportProduct:'PEC6800',
						Version:'1.0',
						Size:'1.93M',
						FileName:'PEC6800用户使用手册.pdf'
					},
					{
						Name:'PEC6900用户使用手册',
						Intro:'介绍了PEC6900的工作原理、技术参数、安装接线、软件功能以及日常维护与故障排查',
						SupportProduct:'PEC6900',
						Version:'1.0',
						Size:'1.93M',
						FileName:''
					},
					{
						Name:'CUS100系列伺服驱动器用户使用手册',
						Intro:'介绍了CUS100系列伺服器的技术参数、安装接线、操作方法、功能详解、通信协议以及保养维护与故障排查',
						SupportProduct:'CUS100系列',
						Version:'1.0',
						Size:'3.22M',
						FileName:'CUS100系列伺服器使用手册.pdf'
					},
					{
						Name:'CUS300系列伺服驱动器用户使用手册',
						Intro:'介绍了CUS300系列伺服器的技术参数、安装接线、操作方法、功能详解、通信协议以及保养维护与故障排查',
						SupportProduct:'CUS300系列',
						Version:'1.0',
						Size:'3.28M',
						FileName:'CUS300系列伺服器使用手册.pdf'
					},
					{
						Name:'VIT100系列变频器用户使用手册',
						Intro:'介绍了VIT100系列变频器的技术参数、安装接线、操作方法、功能详解、通信协议以及保养维护与故障排查',
						SupportProduct:'VIT100系列',
						Version:'1.0',
						Size:'2.5M',
						FileName:'VIT100系列变频器使用手册.pdf'
					},
					{
						Name:'VIT200系列变频器用户使用手册',
						Intro:'介绍了VIT200系列变频器的技术参数、安装接线、操作方法、功能详解、通信协议以及保养维护与故障排查',
						SupportProduct:'VIT200系列',
						Version:'1.0',
						Size:'2.7M',
						FileName:'VIT200系列变频器使用手册.pdf'
					},
					{
						Name:'iTD1015用户使用手册',
						Intro:'介绍了iTD1015的设备参数、硬件安装和软件安装方法',
						SupportProduct:'iTD1015',
						Version:'1.0',
						Size:'839K',
						FileName:'201310121641590012.pdf'
					},
					{
						Name:'PAC实时内核用户手册',
						Intro:'介绍了PAC实时内核用户手册的工作原理、技术参数、安装接线和软件功能',
						SupportProduct:'PAC系列',
						Version:'1.0',
						Size:'2.05M',
						FileName:'201310121644063923.pdf'
					},
					{
						Name:'MCD1000用户使用手册',
						Intro:'介绍了MCD1000的工作原理、技术参数、安装接线、软件功能以及日常维护与故障排查',
						SupportProduct:'MCD1000',
						Version:'1.0',
						Size:'1.93M',
						FileName:'MCD1000用户使用手册.pdf'
					},
					{
						Name:'NCC2010、NCC2020 用户使用手册',
						Intro:'介绍了NCC2010、NCC2020的工作原理、技术参数、安装接线、软件功能以及日常维护与故障排查',
						SupportProduct:'NCC2010、NCC2020',
						Version:'V1.1',
						Size:'704K',
						FileName:'NCC系列说明书V1.1.pdf'
					},
					{
						Name:'NCC2030用户使用手册',
						Intro:'介绍了NCC2030的工作原理、技术参数、安装接线、软件功能以及日常维护与故障排查',
						SupportProduct:'NCC2030',
						Version:'V1.0',
						Size:'1.14M',
						FileName:'NCC2030用户使用手册_V1.0.pdf'
					},
					{
						Name:'NCC2040用户使用手册',
						Intro:'介绍了NCC2040的工作原理、技术参数、安装接线、软件功能以及日常维护与故障排查',
						SupportProduct:'NCC2040',
						Version:'V1.0',
						Size:'1.25M',
						FileName:'NCC2040可编程控制器使用手册_V1.0.pdf'
					},
					{
						Name:'TAC6000说明文档(一)',
						Intro:'TAC6000产品使用说明书。',
						SupportProduct:'TAC6000',
						Version:'1.0',
						Size:'605K',
						FileName:'TAC6000说明书.pdf'
					},
					{
						Name:'TAC6000说明文档(二)',
						Intro:'TAC6000寄存器与控制逻辑组态定义说明。',
						SupportProduct:'TAC6000',
						Version:'v1.2',
						Size:'322K',
						FileName:'TAC6000逻辑输入和输出组态信息定义v1.2.pdf'
					},
					{
						Name:'TAC3000说明文档(一)',
						Intro:'TAC3000产品使用说明书。',
						SupportProduct:'TAC3000',
						Version:'1.0',
						Size:'509K',
						FileName:'TAC3000使用说明书.pdf'
					},
					{
						Name:'TAC3000说明文档(二)',
						Intro:'TAC3000寄存器与控制逻辑组态定义说明。',
						SupportProduct:'TAC3000',
						Version:'v1.2',
						Size:'322K',
						FileName:'TAC3000逻辑输入和输出组态信息定义v1.2.pdf'
					},
					{
						Name:'DUT4000说明文档(一)',
						Intro:'DUT4000产品介绍。',
						SupportProduct:'DUT4000',
						Version:'1.0',
						Size:'256K',
						FileName:'采集模块DUT4000产品介绍.pdf'
					},
					{
						Name:'DUT4000说明文档(二)',
						Intro:'DUT4000数据采集模块MODBUS协议说明。',
						SupportProduct:'DUT4000',
						Version:'1.0',
						Size:'91K',
						FileName:'DUT4000数据采集模块MODBUS协议说明.pdf'
					},
					{
						Name:'DUT4000说明文档(三)',
						Intro:'DUT4000数据采集模块并口输出时序说明。',
						SupportProduct:'DUT4000',
						Version:'1.0',
						Size:'84K',
						FileName:'DUT4000数据采集模块并口输出时序说明.pdf'
					},
					{
						Name:'DUT4000说明文档(四)',
						Intro:'DUT4000产品使用说明书。',
						SupportProduct:'DUT4000',
						Version:'1.0',
						Size:'355K',
						FileName:'DUT4000说明书.pdf'
					},
					{
						Name:'TAM4000说明文档',
						Intro:'TAM4000产品使用说明书。',
						SupportProduct:'TAM4000',
						Version:'1.0',
						Size:'359K',
						FileName:'TAM4000产品说明书.pdf'
					},
					{
						Name:'P51接口板 说明文档',
						Intro:'P51产品使用说明书。',
						SupportProduct:'P51接口板',
						Version:'1.0',
						Size:'350K',
						FileName:'接口板说明书.pdf'
					}
				]
			}
			else if(s == "techDoc"){
				this.tableData = [
					{
						Name:'MCI_DD1000用户使用手册',
						Intro:'介绍了电导调理板的参数、接线方法和软件配置使用方法',
						SupportProduct:'MCI_DD1000',
						Version:'1.0',
						Size:'658K',
						FileName:'MCI_DD1000用户使用手册.pdf'
					},
					{
						Name:'MCI_RY1000用户使用手册',
						Intro:'介绍了溶氧调理板的参数、接线方法和软件配置使用方法',
						SupportProduct:'MCI_RY1000',
						Version:'1.0',
						Size:'586K',
						FileName:'MCI_RY1000用户使用手册.pdf'
					},
					{
						Name:'MCI_PH1000用户使用手册',
						Intro:'介绍了PH调理板的参数、接线方法和软件配置使用方法',
						SupportProduct:'MCI_PH1000',
						Version:'1.0',
						Size:'609K',
						FileName:'MCI_PH1000用户使用手册.pdf'
					},
					{
						Name:'电力监控使用说明',
						Intro:'介绍了电力监控系统的参数、接线方法和软件配置使用方法。\n相关设备：EDC8000+DLC1000',
						SupportProduct:'EDC8000、DLC1000',
						Version:'V1.0',
						Size:'671K',
						FileName:'电力监控使用说明_V1.0.pdf'
					},
					{
						Name:'DCCE设备与西门子通信配置说明—UDP方式',
						Intro:'DCCE设备与西门子300进行以太网通信的配置说明。\n相关设备：MAC系列、PEC系列、EDC系列、MCD1000',
						SupportProduct:'MAC系列、PEC系列、EDC系列、MCD1000',
						Version:'V1.0',
						Size:'1.25M',
						FileName:'DCCE设备与西门子通信配置说明—UDP方式_V1.0.pdf'
					},
					{
						Name:'DCCE设备与西门子通信配置说明—PROFIBUS-DP',
						Intro:'DCCE设备与西门子300进行DP通信的配置说明。\n相关设备：PEC系列(除PEC8000)、DIO系列、AIO系列、EDC系列、MAC系列',
						SupportProduct:'PEC系列、DIO系列、AIO系列、EDC系列、MAC系列',
						Version:'1.0',
						Size:'1.25M',
						FileName:'DCCE设备与西门子通信配置说明.rar'
					},
					{
						Name:'软仪表常见问题解释说明',
						Intro:'介绍了各种软仪表的型号、信号传输过程、结构划分、常用传感器类型、特点及应用场合和仪表电极的推荐厂家等。\n相关设备：MCI_PH1000、MCI_DD1000、 MCI_RY1000、MCI_NA1000',
						SupportProduct:'MCI_PH1000、MCI_DD1000、MCI_RY1000、MCI_NA1000',
						Version:'V1.0',
						Size:'319K',
						FileName:'软仪表常见问题解释说明_V1.0.pdf'
					},
					{
						Name:'软仪表指令使用说明',
						Intro:'介绍了酸碱浓度测量（PH）、电导率测量（DD）、溶氧测量（OXM）、Na离子测量（Na）指令的使用说明。\n相关设备：EDC8000',
						SupportProduct:'EDC8000',
						Version:'V1.0',
						Size:'471K',
						FileName:'软仪表指令使用说明_V1.0.pdf'
					},
					{
						Name:'电力监控板常见问题解释说明',
						Intro:'介绍了电力监控板的型号、信号传输过程、结构划分、特点及应用场合和变压器及电流互感器的要求。\n相关设备：DLC1000',
						SupportProduct:'DLC1000',
						Version:'V1.0',
						Size:'204K',
						FileName:'电力监控板常见问题解释说明_V1.0.pdf'
					},
					{
						Name:'PLC_Config升级说明',
						Intro:'PLC_Config的升级说明和安装注意事项',
						SupportProduct:'PLC_Config',
						Version:'1.0',
						Size:'4K',
						FileName:'PLC_Config升级说明.txt'
					}
				]
			}
			else if(s == "driver"){
				this.tableData = [
					{
						Name:'PEC6000系列产品运动控制指令示例工程(一)',
						Intro:'单轴指令示例工程，此处主要包含各种定位、点动运行、回原点、往复运行、复位轴、读写轴参数、读写轴参数等示例。',
						SupportProduct:'PEC6000系列',
						Size:'1.56M',
						FileName:'单轴指令示例工程.rar'
					},
					{
						Name:'PEC6000系列产品运动控制指令示例工程(二)',
						Intro:'多轴指令示例工程，此处主要包含凸轴运行分离、齿轮运行分离、创建删除凸轮表、读写凸轮表数据，读从轴位置、多轴同步运行等示例。',
						SupportProduct:'PEC6000系列',
						Size:'774K',
						FileName:'多轴指令示例工程.rar'
					},
					{
						Name:'PEC6000系列产品运动控制指令示例工程(三)',
						Intro:'轴组指令示例工程，此处主要包含直线运行、样条运行、点动运行、平面圆弧运行、空间圆弧运行以及各种曲线运行示例。',
						SupportProduct:'PEC6000系列',
						Size:'1.6M',
						FileName:'轴组指令示例工程.rar'
					},
					{
						Name:'PEC6000系列产品运动控制指令示例工程(四)',
						Intro:'其他示例工程，此处主要包含反馈计数、反馈输出、脉冲发送、通用模型、往复运动示例。',
						SupportProduct:'PEC6000系列',
						Size:'410K',
						FileName:'其它示例工程.rar'
					},
					{
						Name:'Modbus 以太网 通讯例程及标准(一)',
						Intro:'包含VB、VC、Delphi、C#、Bland C++环境下Modbus、Modbus_UDP通讯源码、例程及相关说明。',
						SupportProduct:'所有产品',
						Size:'3.16M',
						FileName:'MODBUS通讯代码例程.rar'
					},
					{
						Name:'Modbus 以太网 通讯例程及标准(二)',
						Intro:'包含C++（VS2005）环境下使用Modbus UDP协议与支持以太网协议的PEC、MAC等系列产品的通信例程',
						SupportProduct:'PEC系列、MAC系列',
						Size:'1.54M',
						FileName:'CommDllForC-VS2005(2014-08-19).rar'
					},
					{
						Name:'Modbus 以太网 通讯例程及标准(三)',
						Intro:'Modbus和Modbus TCP官方标准文档。',
						SupportProduct:'所有产品',
						Size:'842K',
						FileName:'MODBUS协议说明(英文).rar'
					},
					{
						Name:'DUT4000 驱动及例程(1)',
						Intro:'西门子S7-200采集DUT4000例程。',
						SupportProduct:'DUT4000',
						Size:'39K',
						FileName:'西门子S7-200采集模块程序.rar'
					},
					{
						Name:'DUT4000 驱动及例程(2)',
						Intro:'DUT4000松下协议下运行软件',
						SupportProduct:'DUT4000',
						Size:'36K',
						FileName:'松下协议下运行软件--DUT4000.rar'
					},
					{
						Name:'DUT4000 驱动及例程(3)',
						Intro:'研华协议采集DUT4000程序。',
						SupportProduct:'DUT4000',
						Size:'2.53MK',
						FileName:'研华协议下运行软件--DUT4000.rar'
					},
					{
						Name:'DUT4000 驱动及例程(4)',
						Intro:'Modbus协议采集DUT4000程序。',
						SupportProduct:'DUT4000',
						Size:'116K',
						FileName:'MODBUS协议下运行软件--DUT4000.rar'
					},
					{
						Name:'DUT4000 驱动及例程(5)',
						Intro:'DUT4000在Modbus RTU协议下与组态王通讯例程。',
						SupportProduct:'DUT4000',
						Size:'9K',
						FileName:'RTU协议下与组态王通讯--DUT4000.rar'
					},
					{
						Name:'DUT4000 驱动及例程(6)',
						Intro:'DUT4000与台达触摸屏通讯例程。',
						SupportProduct:'DUT4000',
						Size:'10K',
						FileName:'台湾台达触摸屏通讯示例.rar'
					},
					{
						Name:'DUT4000 驱动及例程(7)',
						Intro:'西门子S7-300采集DUT4000例程。',
						SupportProduct:'DUT4000',
						Size:'426K',
						FileName:'西门子S7-300采集模块程序.rar'
					},
					{
						Name:'DUT4000 驱动及例程(8)',
						Intro:'欧姆龙CPM2A采集DUT4000例程。',
						SupportProduct:'DUT4000',
						Size:'90K',
						FileName:'欧姆龙CPM2A采集DUT4000.rar'
					},
					{
						Name:'DUT4000 驱动及例程(9)',
						Intro:'三菱PLC采集DUT4000例程。',
						SupportProduct:'DUT4000',
						Size:'90K',
						FileName:'三菱PLC采集DUT4000.rar'
					},
					{
						Name:'DUT4000 驱动及例程(10)',
						Intro:'松下PLC采集DUT4000例程。',
						SupportProduct:'DUT4000',
						Size:'2K',
						FileName:'松下PLC采集DUT4000.rar'
					},
					{
						Name:'DUT4000 驱动及例程(11)',
						Intro:'台达PLC采集DUT4000例程。',
						SupportProduct:'DUT4000',
						Size:'10K',
						FileName:'台达PLC采集DUT4000程序.rar'
					},
					{
						Name:'DUT4000 驱动及例程(12)',
						Intro:'DUT4000与西门子PLC通讯。',
						SupportProduct:'DUT4000',
						Size:'258K',
						FileName:'西门子S7-200采集DUT4000程序.rar'
					},
					{
						Name:'P51接口板驱动(1)',
						Intro:'Linux下温度接口板驱动程序。',
						SupportProduct:'P51接口板',
						Size:'79K',
						FileName:'linux下温度接口板驱动程序--接口板.rar'
					},
					{
						Name:'P51接口板驱动(2)',
						Intro:'DOS下接口板的驱动。',
						SupportProduct:'P51接口板',
						Size:'93K',
						FileName:'DOS下接口板的驱动.rar'
					},
					{
						Name:'P51接口板驱动(3)',
						Intro:'接口板与组态王连接应用示例。',
						SupportProduct:'P51接口板',
						Size:'65K',
						FileName:'接口板与组态王连接.rar'
					},
					{
						Name:'P51接口板驱动(4)',
						Intro:'接口板与genie连接应用示例。',
						SupportProduct:'P51接口板',
						Size:'13K',
						FileName:'接口板与genie连接.rar'
					},
					{
						Name:'P51接口板驱动(5)',
						Intro:'读取接口板OCX控件。',
						SupportProduct:'P51接口板',
						Size:'3.68M',
						FileName:'读取接口板OCX控件.rar'
					},
					{
						Name:'P51接口板驱动(6)',
						Intro:'Win95下读取接口板驱动程序。',
						SupportProduct:'P51接口板',
						Size:'67K',
						FileName:'Win95下读取接口板驱动程序.rar'
					},
					{
						Name:'P51接口板驱动(7)',
						Intro:'Windows 2000下读取接口板驱动程序。',
						SupportProduct:'P51接口板',
						Size:'618K',
						FileName:'Windows2000系统驱动程序.rar'
					},
					{
						Name:'P51接口板驱动(8)',
						Intro:'Win31下读取接口板驱动程序。',
						SupportProduct:'P51接口板',
						Size:'27K',
						FileName:'Win31下读取接口板驱动程序.rar'
					}
				]
			}
			else if(s =="communiate"){
				this.tableData = [
					{
						Name:'DCCE触摸屏与DCCE(PLC)串口通信示例',
						Intro:'DCCE触摸屏与DCCE(PLC)串口通信示例<br>支持设备：PEC系列、DIO系列、AIO系列、EDC系列、MAC系列',
						SupportProduct:'PEC系列、DIO系列、AIO系列、EDC系列、MAC系列',
						Size:'4.34M',
						FileName:'DCCE触摸屏与DCCE(PLC)串口通信示例.rar'
					},
					{
						Name:'DCCE触摸屏与DCCE(PLC)以太网通信示例',
						Intro:'DCCE触摸屏与DCCE(PLC)以太网通信示例<br>支持设备：PEC系列、EDC系列、MAC系列',
						SupportProduct:'PEC系列、EDC系列、MAC系列',
						Size:'4.98M',
						FileName:'DCCE触摸屏与DCCE(PLC)以太网通信示例.rar'
					},
					{
						Name:'昆仑通态触摸屏与DCCE串口PLC通信示例',
						Intro:'昆仑通态触摸屏与DCCE串口PLC通信示例<br>支持设备：PEC系列、DIO系列、AIO系列、EDC系列、MAC系列',
						SupportProduct:'PEC系列、DIO系列、AIO系列、EDC系列、MAC系列',
						Size:'816K',
						FileName:'昆仑通态触摸屏与DCCE串口PLC通信示例.rar'
					},
					{
						Name:'昆仑通态触摸屏与DCCE以太网PLC通信示例',
						Intro:'昆仑通态触摸屏与DCCE以太网PLC通信示例<br>支持设备：PEC系列、EDC系列、MAC系列',
						SupportProduct:'PEC系列、EDC系列、MAC系列',
						Size:'4.98M',
						FileName:'昆仑通态触摸屏与DCCE以太网PLC通信示例.rar'
					},
					{
						Name:'老串口自由通信指令示例工程',
						Intro:'通过串口自由通信发送、接收指令实现自由格式的报文传输<br>支持设备：PEC系列、DIO系列、AIO系列、EDC系列',
						SupportProduct:'PEC系列、DIO系列、AIO系列、EDC系列',
						Size:'184K',
						FileName:'老串口自由通信示例工程.rar'
					},
					{
						Name:'新UDP自由通信指令示例工程',
						Intro:'通过UDP自由通信指令发送一条标准的ModbusUDP报文，并接收响应<br>支持设备：MAC系列',
						SupportProduct:'MAC系列',
						Size:'654K',
						FileName:'新UDP自由通信指令示例工程.rar'
					},
					{
						Name:'EPA通信指令示例工程',
						Intro:'以EPA字读、写指令为例说明EPA通信指令的用法<br>支持设备：PEC系列、EDC系列、MAC系列',
						SupportProduct:'PEC系列、EDC系列、MAC系列',
						Size:'3.39M',
						FileName:'EPA通信指令示例工程.rar'
					},
					{
						Name:'新串口自由通信指令示例工程',
						Intro:'通过串口自由通信发送、接收指令实现自由格式的报文传输<br>支持设备：MAC系列',
						SupportProduct:'MAC系列',
						Size:'1.79M',
						FileName:'新串口自由通信示例工程.rar'
					},
					{
						Name:'新TCP自由通信指令示例工程',
						Intro:'通过TCP自由通信指令发送一条标准的ModbusTCP报文，并接收响应<br>支持设备：MAC系列',
						SupportProduct:'MAC系列',
						Size:'557K',
						FileName:'新TCP自由通信指令示例工程.rar'
					},
					{
						Name:'串行通信指令示例工程',
						Intro:'以串行字读、写指令为例说明串行通信指令的用法<br>支持设备：PEC系列、DIO系列、AIO系列、EDC系列、MAC系列',
						SupportProduct:'PEC系列、DIO系列、AIO系列、EDC系列、MAC系列',
						Size:'117K',
						FileName:'串行通信指令示例工程.rar'
					}
				]
			}
		},
		beforeUpdate(){			

		},
		destroyed() {},
		methods: {
			handleEdit(index, row) {
				// this.$refs.dialog.visible = true;
				// this.showMsg = true;
				// // 显示确定编辑的弹窗
				//console.log(index);
				// console.log(row);
				// let res = UploadService.DownloadFile(row)


				let downSign = this.$route.meta.downSign;
				let a = document.createElement('a')
				a.style.display = 'none'
				a.href ='http://'+global.__fileServer+'/files/'+downSign+'|'+row
				// a.href = window.location.origin +'/files/'+downSign+'|'+row
				document.body.appendChild(a)
				a.click() //执行下载
				window.URL.revokeObjectURL(a.href) //释放url
				document.body.removeChild(a) //释放标签

			},
			handleDelete(index, row) {
				// this.$refs.dialog.visible = true;
				this.showMsg = false;
				// 提示是否确认删除
				console.log(index);
				console.log(row);
			},
			/**
			 *@description: 点击确定执行的方法
			 */
			confirm() {
				// this.$refs.dialog.visible = false;
				console.log('执行确认方法');
			},
		},
	};
</script>
<style lang='scss' scoped>
	.customzie {
		width: 100%;
		height: vh(950);
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
	}
	.msg{
		white-space: pre-wrap;
		word-break: break-all;
	}

	/* PC端显示表格，移动端隐藏 */
	.pc-table {
		display: block;
	}
	.mobile-card-list {
		display: none;
	}

	/* 移动端适配：屏幕宽度小于768px */
	@media (max-width: 768px) {
		.customzie {
			height: auto;
			min-height: 400px;
			padding: 10px;
			box-sizing: border-box;
		}

		/* 移动端隐藏表格，显示卡片 */
		.pc-table {
			display: none;
		}
		.mobile-card-list {
			display: block;
		}

		/* 卡片样式 */
		.mobile-card {
			background: #fff;
			border-radius: 8px;
			padding: 12px 15px;
			margin-bottom: 12px;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

			.card-item {
				display: flex;
				padding: 6px 0;
				border-bottom: 1px solid #f0f0f0;
				font-size: 13px;
				line-height: 1.5;

				&:last-of-type {
					border-bottom: none;
				}

				.card-label {
					flex-shrink: 0;
					width: 70px;
					color: #909399;
					font-weight: 500;
				}

				.card-value {
					flex: 1;
					color: #303133;
					word-break: break-all;
				}
			}

			.card-action {
				text-align: right;
				padding-top: 10px;
				margin-top: 5px;
			}
		}
	}

	/* 小屏手机适配：屏幕宽度小于480px */
	@media (max-width: 480px) {
		.mobile-card {
			padding: 10px 12px;

			.card-item {
				font-size: 12px;

				.card-label {
					width: 60px;
				}
			}
		}
	}
</style>
